import { apiClient } from "./api";

/**
 * Decross（坊市）发布 API 客户端封装（frontend → /api/v1/debugpavilion 的发布端点）。
 *
 * - POST /debugpavilion/{id}/publish         —— 触发发布（202：异步打包+提交）
 * - GET  /debugpavilion/{id}/publish/status  —— 查询发布/审核状态
 */

/** 触发发布后的立即响应（202，异步后台执行）。 */
export interface DecrossPublishResponse {
  app_id: string;
  publish_id: string;
  /** 固定为 "pending"（打包/提交在后台执行）。 */
  status: string;
  detail?: string;
}

/** 发布流程状态（前端徽标取值）。 */
export type DecrossPublishState =
  | "not_submitted" // 未发布
  | "pending" // 发布中（打包/提交后台执行）
  | "submitted" // 已提交到坊市（decross_status 细分审核状态）
  | "error"; // 发布失败

/** 发布状态查询响应。 */
export interface DecrossPublishStatus {
  app_id: string;
  status: DecrossPublishState | string;
  publish_id: string | null;
  decross_app_id: string | null;
  /** decross 侧审核状态：draft（审核中）/ published（已发布）/ rejected（已拒绝）。 */
  decross_status: string | null;
  error: string | null;
  review_reason: string | null;
  submitted_at: string | null;
  checked_at: string | null;
}

/** 触发「发布到坊市」（202，后台打包提交，立即返回 pending）。 */
export async function publishAppToDecross(appId: string): Promise<DecrossPublishResponse> {
  const response = await apiClient.post<DecrossPublishResponse>(`/debugpavilion/${appId}/publish`);
  return response.data;
}

/** 查询应用在坊市的发布/审核状态。 */
export async function getDecrossPublishStatus(appId: string): Promise<DecrossPublishStatus> {
  const response = await apiClient.get<DecrossPublishStatus>(`/debugpavilion/${appId}/publish/status`);
  return response.data;
}
